module.exports = __webpack_public_path__ + "img/step_four_brands.3294cf87.jpg";